/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { WorkingModeBlockedItemReasonCode } from './workingModeBlockedItemReasonCode';

export interface WorkingModeBlockedItem {
  id: string;
  reasonCode: WorkingModeBlockedItemReasonCode;
}
